import type { ConfigType } from '@plone/registry';
import type { CustomInheritBehavior, BlocksConfigSettings } from './types';
import installSettings from './config/settings';
import installSlots from './config/slots';

declare module '@plone/types' {
  export interface GetSiteResponse {
    'kitconcept.intranet.custom_css': string;
  }

  export interface Expanders {
    inherit: {
      'kitconcept.blocks.config': CustomInheritBehavior<BlocksConfigSettings>;
    };
  }
}

const applyConfig = (config: ConfigType) => {
  installSettings(config);
  installSlots(config);
  return config;
};

export default applyConfig;
